export default
{
    path: '/ks-main',
    name: 'ks-main',
    component: () => import('../views/static/ks-main.vue'),
    children:[
        {
            path: "ks-index",
            name: "ks-index",
            component: () => import('../views/static/ks-index.vue'),
        },
        {
            path: "ks-news",
            name: "ks-news",
            component: () => import('../views/static/ks-news.vue'),
        },
        {
            path: "ks-news-content",
            name: "ks-news-content",
            component: () => import('../views/static/ks-news-content.vue'),
        },
        {
            path: "ks-investor",
            name: "ks-investor",
            component: () => import('../views/static/ks-investor.vue'),
        },
        {
            path: "ks-investor-2",
            name: "ks-investor-2",
            component: () => import('../views/static/ks-investor-2.vue'),
        },
        {
            path: "ks-investor-3",
            name: "ks-investor-3",
            component: () => import('../views/static/ks-investor-3.vue'),
        },
        {
            path: "ks-investor-4",
            name: "ks-investor-4",
            component: () => import('../views/static/ks-investor-4.vue'),
        },
        {
            path: "ks-investor-5",
            name: "ks-investor-5",
            component: () => import('../views/static/ks-investor-5.vue'),
        },
        {
            path: "ks-investor-6",
            name: "ks-investor-6",
            component: () => import('../views/static/ks-investor-6.vue'),
        },
        {
            path: "ks-investor-7",
            name: "ks-investor-7",
            component: () => import('../views/static/ks-investor-7.vue'),
        },
        {
            path: "ks-about-us",
            name: "ks-about-us",
            component: () => import('../views/static/ks-about-us.vue'),
        },
        {
            path: "ks-society",
            name: "ks-society",
            component: () => import('../views/static/ks-society.vue'),
        },
        {
            path: "ks-join-us",
            name: "ks-join-us",
            component: () => import('../views/static/ks-join-us.vue'),
        },
        {
            path: "ks-recruit-list",
            name: "ks-recruit-list",
            component: () => import('../views/static/ks-recruit-list.vue'),
        },
        {
            path: "ks-recruit-JD",
            name: "ks-recruit-JD",
            component: () => import('../views/static/ks-recruit-JD.vue'),
        }
    ]
}
